import {
  AppBar,
  Box,
  IconButton,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export const StyledNavbar = styled(AppBar)(({ theme }) => ({
  background: theme.palette.custom.white,
  boxShadow: "none",
  borderRadius: theme.borderRadius.radius.regular,
  position: "static",
  flexShrink: 0,
  width: "100%",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const StyledToolbar = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "65px",
  padding: "18px 16px",
}));
export const StyledIcon = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: " 12px",
}));
export const StyledWalletBalance = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  background: theme.palette.custom.walletBg,
  padding: "6px 16px",
  borderRadius: theme.borderRadius.radius.wallet,
  marginRight: "10px",
  width: "139px",
}));
export const StyledWalletText = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));
export const StyledWalletLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.tiny.fontSize,
  color: theme.palette.custom.walletFont,
  [theme.breakpoints.down("xl")]: {
    fontSize: theme.typography.xlBreakpoint.fontSize,
  },
}));
export const StyledWalletAmount = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  color: theme.palette.custom.walletAmount,
}));
export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  background: theme.palette.custom.iconBg,
  width: "40px",
  height: "40px",
}));
export const StyledAvatar = styled("img")(() => ({
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  objectFit: "cover",
}));
export const StyledAvatarWrapper = styled("div")(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  cursor: "pointer",
  overflow: "hidden",
  flexShrink: 0,
}));
export const StyledAvatarInitials = styled("div")(({ theme }) => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.custom.white,
  fontWeight: theme.typography.fontWeight.bold,
  fontSize: theme.typography.base.fontSize,
}));
export const StyledNavbarSearch = styled(TextField)(({ theme }) => ({
  height: "36px",
  width: "100%",
  "& .MuiInputBase-input": {
    fontSize: theme.typography.small.fontSize,
  },
  "& .MuiOutlinedInput-root": {
    height: "36px",
    paddingLeft: "20px",
    borderRadius: theme.borderRadius.radius.medium,
    background: theme.palette.custom.searchBg,
    color: theme.palette.custom.orderButtonColor,
  },
  "& .MuiOutlinedInput-input": {
    padding: "0px",
    background: "transparent",
  },
  "& fieldset": { border: "none" },
}));
export const StyledSearchIcon = styled(SearchIcon)(() => ({
  width: "17px",
  height: "17px",
}));
